export function ZoningRegulations() {
  const zoningRules = [
    {
      zone: 'RS (Single Family Residential)',
      allowed: 'Permitted with restrictions',
      requirements: [
        'Principal residence requirement applies',
        'Maximum 2 bedrooms can be rented',
        'Owner must be present during rental period',
        'Minimum 30-day rental periods in some areas'
      ],
      icon: 'ri-home-4-line'
    },
    {
      zone: 'RM (Multi-Family Residential)',
      allowed: 'Restricted or prohibited',
      requirements: [
        'Most strata buildings prohibit STR',
        'Check strata bylaws before proceeding',
        'Individual unit restrictions may apply',
        'Building-specific approval required'
      ],
      icon: 'ri-building-line'
    },
    {
      zone: 'Commercial Mixed-Use',
      allowed: 'Case-by-case basis',
      requirements: [
        'Zoning variance may be required',
        'Commercial licensing needed',
        'Fire safety inspections mandatory',
        'Parking requirements must be met'
      ],
      icon: 'ri-store-2-line'
    },
    {
      zone: 'Rural/Agricultural',
      allowed: 'Limited permissions',
      requirements: [
        'Farm status may affect eligibility',
        'Accessory dwelling restrictions',
        'Environmental considerations',
        'Agricultural Land Reserve rules apply'
      ],
      icon: 'ri-plant-line'
    }
  ];

  return (
    <section className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className="font-['Fraunces'] text-4xl lg:text-5xl font-bold text-[#505A5A] mb-6">
            Zoning-Specific Regulations
          </h2>
          <p className="text-lg text-[#505A5A]/70 leading-relaxed">
            North Vancouver's short term rental rules vary significantly by zoning designation. Understanding your property's zone is critical for compliance.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {zoningRules.map((zone, index) => (
            <div 
              key={index}
              className="bg-[#F0F0F0] rounded-2xl p-8 hover:shadow-xl transition-all"
            >
              <div className="flex items-start gap-4 mb-6">
                <div className="w-14 h-14 flex items-center justify-center bg-[#882629] rounded-xl flex-shrink-0">
                  <i className={`${zone.icon} text-2xl text-white`}></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-[#505A5A] mb-2">
                    {zone.zone}
                  </h3>
                  <span className={`inline-block px-4 py-1 rounded-full text-sm font-medium ${
                    zone.allowed.includes('Permitted') 
                      ? 'bg-green-100 text-green-800' 
                      : zone.allowed.includes('Restricted')
                      ? 'bg-yellow-100 text-yellow-800'
                      : 'bg-blue-100 text-blue-800'
                  }`}>
                    {zone.allowed}
                  </span>
                </div>
              </div>

              <ul className="space-y-3">
                {zone.requirements.map((req, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-[#882629] text-lg flex-shrink-0 mt-0.5"></i>
                    <span className="text-[#505A5A]/80 text-base leading-relaxed">
                      {req}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-[#882629]/5 border-l-4 border-[#882629] rounded-lg p-6">
          <div className="flex items-start gap-4">
            <i className="ri-alert-line text-2xl text-[#882629] flex-shrink-0 mt-1"></i>
            <div>
              <h4 className="text-lg font-semibold text-[#505A5A] mb-2">
                Important Zoning Notice
              </h4>
              <p className="text-[#505A5A]/70 leading-relaxed">
                Zoning regulations are subject to change and may have additional restrictions not listed here. Always verify current zoning status with the District or City of North Vancouver planning department before operating a short term rental.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
